export default "__VITE_ASSET__Cjt58JEa__"